module.exports = __webpack_public_path__ + "static/img/discussion_susscess.3def3c5e.jpg";